module.exports = __webpack_public_path__ + "static/media/flow-chart-pc.c0b5410b.png";